export function removeTrailingSlash(req, res) {
    const pathname = req.url.pathname;
    if (pathname !== '/' && pathname.endsWith('/')) {
        const newPathname = pathname.slice(0, -1);
        return res.redirect(newPathname, 301);
    }
}
